import { Component, HostListener, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { StepService } from 'src/app/services/step.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(private step: StepService) {}
  idCheckati: string[] = [];
  isPhone: boolean = false;
  stepperService = StepService;
  showRiepilogo: boolean = false;
  showRingraziamenti: boolean = false;
  private subscription = new Subscription();
  ngOnInit(): void {
    this.subscription = this.step
      .getShowRiepilogo()
      .subscribe((showRiepilogo) => {
        this.showRiepilogo = showRiepilogo;
      });
    this.subscription = this.step
      .getShowRingraziamenti()
      .subscribe((showRingraziamenti) => {
        this.showRingraziamenti = showRingraziamenti;
        console.log(showRingraziamenti);
      });
  }

  setRiepilogo() {
    this.showRiepilogo = !this.showRiepilogo;
    this.step.setShowRiepilogo(this.showRiepilogo);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
